/**
 * @typedef {import('../MapLibreMap.js').MLD} MLD
 */


window.OSM = window.OSM ?? {};

/**
 *
 * @param colour {string|null=}
 * @returns {boolean}
 */
OSM.isColor = (colour) => {
    if(!colour){
        return false;
    }
    const s = new Option().style;
    s.color = colour;
    return s.color !== '';
}


/**
 *
 * @param pointLike {MLD._PointLike=}
 * @returns {MLD._Point}
 */
OSM.requirePoint = (pointLike) => {
    if(pointLike instanceof maplibregl.Point){
        return pointLike;
    }
    return new maplibregl.Point(pointLike[0], pointLike[1]);
}
/**
 *
 * @param colour {string|null=}
 * @returns {string|null}
 */
OSM.normalizeColor = (colour) => {
    if(!colour){
        return null;
    }
    if(OSM.isColor(colour)){
        return colour;
    }
    colour = "#"+colour;
    return OSM.isColor(colour) ? colour: null;
}


/**
 *
 * @param object {Object.<string, *>}
 * @returns {Object.<string, *>}
 */
OSM.keySort = (object) => {

    return Object.keys(object).sort().reduce(
        (obj, key) =>
        {
            obj[key] = object[key];
            return obj;
        },
        {}
    );
}

/**
 *
 * @param degrees {number}
 * @returns {number}
 */
OSM.degreesToRadians = (degrees) =>
{
    // Multiply degrees by pi divided by 180 to convert to radians.
    return degrees * (Math.PI / 180);
}

/**
 *
 * @param radians {number}
 * @returns {number}
 */
OSM.radiansToDegrees = (radians) =>
{
    // Multiply radians by 180 divided by pt to convert to degrees.
    return radians * (180 / Math.PI)
}

/**
 *
 * @param num {number}
 * @returns {string}
 */
OSM.formatNumber = (num) =>
{
    const numString = num.toString();
    const numStringParts = numString.split(".");
    const array = numStringParts[0].split('');
    let index = -3;
    while (array.length + index > 0)
    {
        array.splice(index, 0, ',');
        // Decrement by 4 since we just added another unit to the array.
        index -= 4;
    }
    return array.join('') + (numStringParts.length > 1 ? "." + numStringParts[1] : "");
}

/**
 *
 * @param value {*}
 * @returns {boolean}
 */
OSM.isAnyNull = (value) =>
{
    return (value ?? null) === null;
}

/**
 *
 * @param value {*}
 * @returns {boolean}
 */
OSM.isBool = (value) =>
{
    return (value === true) || (value === false);
}

/**
 *
 * @param value {*}
 * @returns {boolean}
 */
OSM.isNumeric = (value) =>
{
    return !OSM.isAnyNull(value) && !isNaN(value) && value !== "" && !OSM.isBool(value);
}

/**
 *
 * @param value {*}
 * @returns {boolean}
 */
OSM.isInt = (value) =>
{
    if(!OSM.isNumeric(value)){
        return false;
    }
    return parseInt(value) === parseFloat(value);
}


/**
 *
 * @param value {*}
 * @param notEmpty {boolean=}
 * @returns {boolean}
 */

OSM.isArray = (value, notEmpty) =>
{
    return !!value && Array.isArray(value) && (!notEmpty || !!value.length);
}

/**
 *
 * @param value {*}
 * @param notEmpty {boolean=}
 * @returns {boolean}
 */
OSM.isObject = (value, notEmpty)=>
{
    return !!value && typeof value === 'object' && !OSM.isArray(value) && (!notEmpty || !!Object.keys(value).length);
}

/**
 *
 * @param value {*}
 * @param notEmpty {boolean=}
 * @returns {boolean}
 */
OSM.isNativeObject = (value, notEmpty)=>
{
    if(!OSM.isObject(value, notEmpty))
    {
        return false;
    }
    return Object.prototype.toString.call(value) === "[object Object]";
}

/**
 *
 * @param objectA {*}
 * @param objectB {*}
 * @param overwrite {boolean=}
 * @returns {boolean}
 */
OSM.deepMergeObjects = (objectA, objectB, overwrite) => {
    if(!OSM.isNativeObject(objectA) || !OSM.isNativeObject(objectB)){
        return false;
    }
    let didChange = false;
    for(const key in objectB){
        if(OSM.isNativeObject(objectA[key]) && OSM.isNativeObject(objectB[key])){
            didChange = OSM.deepMergeObjects(objectA[key], objectB[key], overwrite) || didChange;
        } else if(!objectA.hasOwnProperty(key) || overwrite) {
            if((objectB[key] !== objectA[key]) || !objectA.hasOwnProperty(key)){
                didChange = true;
            }
            objectA[key] = objectB[key];
        }
    }
    return didChange;
}

/**
 *
 * @param object {*}
 * @returns {Object}
 */
OSM.deepCopyObjects = (object) => {
    if(!OSM.isNativeObject(object)){
        return false;
    }
    const value = {};
    for(const key in object){
        const subValue = object[key];
        if(OSM.isNativeObject(object[key])){
            value[key] = OSM.deepCopyObjects(subValue);
        } else {
            value[key] = subValue;
        }
    }
    return value;
}

OSM.DeferredPromise = class DeferredPromise extends Promise {

    /** @type {(_?: T | PromiseLike<T>) => void} */
    resolve = (_) => {

    };
    /** @type {(_?: U) => void} */
    reject = (_) => {

    };

    /**
     *
     * @param executor {(resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void}
     */
    constructor(executor) {
        super(executor);
    }
}

/**
 *
 * @returns {OSM.DeferredPromise}
 */
OSM.createDeferredPromise = () => {
    /** @type {((value: T | PromiseLike<T>) => void)|(() => void)} */
    let promiseResolve = null;
    /** @type {((reason?: U) => void)|(() => void)} */
    let promiseReject = null;
    const promise = new OSM.DeferredPromise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    })
    promise.resolve = promiseResolve;
    promise.reject = promiseReject;
    return promise;
}

OSM.removeFocus = () => {
    const focusElements = document.querySelectorAll(":focus");
    for(let element of focusElements){
        /** @type {HTMLElement|null} */
        const htmlElement = element instanceof HTMLElement ? element : null;
        if(htmlElement){
            htmlElement.focus();
            htmlElement.blur();
        }
    }
}


/**
 *
 * @param {HTMLElement} osmMap
 * @returns {string}
 */
OSM.requireMapID = (osmMap) => {
    let mapID = osmMap.id;
    if(!mapID){
        const prefix = "mapLibreMap"
        let mapNumber = 1;
        mapID = prefix + mapNumber;
        while(document.querySelectorAll("#"+mapID).length){
            mapNumber ++;
            mapID = prefix + mapNumber;
        }
        osmMap.id = mapID;
    }
    return mapID;
}



/**
 *
 * @param {string} mapConfigID
 * @returns {IMapProps}
 */
OSM.createMapProps = (mapConfigID) => {
    /** @type {IMapProps} */
    let config = mapConfigID ? (OSM.MapConfigs[mapConfigID] ?? null) : null;
    config = config ?? OSM.MapConfigs.default;
    config = config ?? {};
    return OSM.deepCopyObjects(config);
}


OSM.CooldownHandler = class CooldownHandler {

    catchLast = false;
    delay = 1000;
    hasCooldown = false;

    /** @type {((resolved:boolean) => void)|null} */
    queuedCallback = null;

    /**
     *
     * @param catchLast {boolean=}
     * @param delay {number=}
     */
    constructor(catchLast, delay) {
        this.catchLast = !!catchLast;
        this.delay = Math.max(Math.round(delay ?? this.delay), 1);
    }

    /**
     *
     * @returns {Promise<void>}
     */
    async available()
    {
        return new Promise(
            /**
             *
             * @param resolve {((value:void|PromiseLike<void>) => void)|(() => void)}
             * @param _ {((reason: *) => void)|(() => void)}
             */
            (resolve, _) => {
                if(this.hasCooldown){
                    if(this.queuedCallback){
                        this.queuedCallback(false)
                    }
                    this.queuedCallback = this.catchLast ?
                        /**
                         *
                         * @param resolved {boolean}
                         */
                            (resolved) => {
                            if(!resolved || this.hasCooldown){
                                return;
                            }
                            this.available().then(() =>{
                                resolve();
                            })
                        }
                        : null;
                    return;
                }
                this.hasCooldown = true;
                this.queuedCallback = null;
                resolve();
                setTimeout(()=>{
                    this.hasCooldown = false;
                    if(this.queuedCallback){
                        this.queuedCallback(true)
                    }
                }, this.delay)
            }
        );
    }
}